import { StudyTranslation } from './study-translation';
import { Subsection } from './subsection';

export interface Section {
  id?: number;
  feedbackTemplateId?: number;
  translations?: StudyTranslation[];
  subsections?: Subsection[];
  created?: boolean;
  sectionName?: string;
  type?: string;
  imageUrl?: string;
  hyperlink?: string;
  linkToSection?: number;
  sortOrder?: number;
}

export enum SectionType {
  DESCRIPTION = 'Description',
  GENERIC_GRAPH = 'Generic graph',
  PROFILE = 'Profile',
  DIMENSION = 'Dimension',
}
